/**
 * Checks if the provided value is not `null` and not `undefined` and returns it as `NonNullable`
 * @param value The value to check for `NonNullable`
 * @returns Type predicate value as `NonNullable` type (excludes null and undefined from T)
 */
export const isNotNullish = <T>(value: T): value is NonNullable<T> => {
  if (value === null) return false;
  if (value === undefined) return false;
  return true;
};
